import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectInputReason from '../../Common/SelectInputReason/SelectInputReason';
import { AVAILABLE_FIELDS_CONFIG, DTSelectActionReasonView } from '../../DTSelectActionReasonView';
import {
  getActionReasons,
  getBrandOfSelectedTicket,
  getDecisionNodeAtPath,
  getSimplrAccountIdOfSelectedTicket,
  getNumberCustomerSupportTransactions,
  getRbiCustomerId,
} from '../../../../../../extractFromState';
import { getRemediationReasons } from '../../../../../../api/orders/rbi';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { setLoading } from '../../../../../../actions';
import { handleError } from '../../../../../../services/ErrorService/ErrorService';

const DTRBISelectPointsReasonNode = () => {
  const dispatch = useDispatch();
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const actionReasons = useSelector(getActionReasons);
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const brandName = useSelector(getBrandOfSelectedTicket);
  const numberCustomerSupportTransactions = useSelector(getNumberCustomerSupportTransactions);
  const customerId = useSelector(getRbiCustomerId);
  const [options, setOptions] = useState([]);

  const handleNextButtonClick = useCallback(() => {
    if (decisionNode.maxTransactions && numberCustomerSupportTransactions >= parseInt(decisionNode.maxTransactions)) {
      dispatch(addEdgeToDecisionTreePath('max_transactions_limit_exceeded'));

      return;
    }

    dispatch(addEdgeToDecisionTreePath('reason_selected'));
  }, [decisionNode, dispatch, numberCustomerSupportTransactions]);

  useEffect(() => {
    if (!decisionNode.reasonRequired) {
      return handleNextButtonClick();
    }

    (async () => {
      try {
        dispatch(setLoading(true, 'reasonContainer'));
        const reasons = await getRemediationReasons({ simplrAccountId, brandName, customerId });
        if (Array.isArray(reasons)) {
          setOptions(reasons);
        }
      } catch (error) {
        handleError({ error, showPopup: true });
      } finally {
        dispatch(setLoading(false, 'reasonContainer'));
      }
    })();
  }, [decisionNode, dispatch, handleNextButtonClick, simplrAccountId, brandName, customerId]);

  return decisionNode.reasonRequired ? (
    <DTSelectActionReasonView
      isNextButtonActive={actionReasons?.pointsPrimaryReason}
      onNextButtonClick={handleNextButtonClick}
    >
      <SelectInputReason
        placeholder="Select points reason"
        options={options}
        fields={AVAILABLE_FIELDS_CONFIG.pointsPrimaryReason}
      />
    </DTSelectActionReasonView>
  ) : null;
};

export default DTRBISelectPointsReasonNode;
